import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    ClientName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    description: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    operation: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Business Name*',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type*',
            options: [
              { label: 'Anniversary', value: 'Anniversary' },
              { label: 'Baby Shower', value: 'Baby Shower' },
              { label: 'Banquet', value: 'Banquet'},
              { label: 'Baptisms', value: 'Baptisms' },
              { label: 'Bar Mitzvah', value: 'Bar Mitzvah' },
              { label: 'Bat Mitzvah', value: 'Bat Mitzvah' },
              { label: 'Birthday Party', value: 'Birthday Party' },
              { label: 'Bridal Shower', value: 'Bridal Shower' },
              { label: 'Communion', value: 'Communion' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Farewell Party', value: 'Farewell Party' },
              { label: 'Funeral', value: 'Funeral' },
              { label: 'Graduation Party', value: 'Graduation Party' },
              { label: 'Holiday Party - House', value: 'Holiday Party - House' },
              { label: 'Holiday Party - Office', value: 'Holiday Party - Office' },
              { label: 'Meeting' , value: 'Meeting'},
              { label: 'Office Party', value: 'Office Party' },
              { label: 'Open House', value: 'Open House' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Retirement', value: 'Retirement' },
              { label: 'Seminar', value: 'Seminar' },
              { label: 'Tasting - Pick Up', value: 'Tasting - Pick Up' },
              { label: 'Tasting - Sit Down', value: 'Tasting - Sit Down' },
              { label: 'Vow Renewal', value: 'Vow Renewal' },
              { label: 'Wedding Reception', value: 'Wedding Reception'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments/Message*',
            mapping: 'description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Cooked Goose Catering Contact Form',
    formId: '650',
    clientKey: 'D1864AF4-2EF9-4F74-B614-ACA1316C82C6',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.cookedgoosecatering.com/thank-you/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/cookedgoosecatering/form_structure.js